<div class="bg-white rounded-lg p-6 border border-gray-200 shadow-sm mb-6">
    <!-- Header Section -->
    <div class="flex items-center justify-between mb-4">
        <div class="flex items-start gap-2 flex-1">

            <div class="flex-1">
                @if (isHandset()) {
                <div class="flex items-baseline gap-2 flex-wrap">
                    <h6 class="text-md font-semibold text-gray-900">{{ parkingSpace.name || ('spaceItem.unnamed' | translate) }}
                    </h6>
                    <!-- Validation status indicator for parking space -->
                    @if (parkingSpace.isValid === false) {
                    <button type="button" (click)="onInfoClick($event, parkingSpace.id)"
                        class="flex items-center justify-center w-5 h-5 rounded-full bg-red-100 hover:bg-red-200 transition-colors flex-shrink-0"
                        [title]="'spaceItem.showValidationErrors' | translate">
                        <svg class="h-3 w-3 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>
                    } @else if (parkingSpace.isValid === true) {
                    <div class="flex items-center justify-center w-5 h-5 rounded-full bg-green-100 flex-shrink-0">
                        <svg class="h-3 w-3 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    }
                </div>
                }
                @else {
                <div class="flex items-baseline gap-2 flex-wrap">
                    <h2 class="text-xl font-semibold text-gray-900">{{ parkingSpace.name || ('spaceItem.unnamed' | translate) }}
                    </h2>
                    <!-- Validation status indicator for parking space -->
                    @if (parkingSpace.isValid === false) {
                    <button type="button" (click)="onInfoClick($event, parkingSpace.id)"
                        class="flex items-center justify-center w-5 h-5 rounded-full bg-red-100 hover:bg-red-200 transition-colors flex-shrink-0"
                        [title]="'spaceItem.showValidationErrors' | translate">
                        <svg class="h-3 w-3 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 0 100-2v-3a1 1 0 00-1-1H9z"
                                clip-rule="evenodd" />
                        </svg>
                    </button>
                    } @else if (parkingSpace.isValid === true) {
                    <div class="flex items-center justify-center w-5 h-5 rounded-full bg-green-100 flex-shrink-0">
                        <svg class="h-3 w-3 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                    }
                </div>
                }
            </div>
        </div>

        <!-- Zone Navigation Buttons -->
        @if(!isHandset() && !isRestrictedMember())
        {
        <div class="flex gap-2">
            <button type="button" (click)="scrollZonesLeft(parkingSpace.id || '')"
                class="inline-flex items-center justify-center w-8 h-8 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
                [title]="'spaceItem.scrollLeft' | translate">
                <svg class="h-4 w-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <button type="button" (click)="scrollZonesRight(parkingSpace.id || '')"
                class="inline-flex items-center justify-center w-8 h-8 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
                [title]="'spaceItem.scrollRight' | translate">
                <svg class="h-4 w-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
        }
    </div>

    <!-- Parking Space Image Section -->
    <div class="mb-4 relative w-48">
        <!-- Hidden file input -->
        <input type="file" #fileInput class="hidden" accept="image/jpeg,image/png,image/gif,image/webp"
            (change)="onFileSelected($event)" />

        <jjames-image-container size="xl" aspectRatio="landscape" [imageSrc]="getSpaceImage()"
            [altText]="'spaceItem.imageAlt' | translate" [placeholderText]="'spaceItem.imagePlaceholder' | translate" [showPlaceholderIcon]="true"
            [rounded]="true" [border]="true">
        </jjames-image-container>

        <!-- Upload overlay button -->
        @if (!isRestrictedMember()) {
        <div class="absolute inset-0 flex items-center justify-center hover:bg-black/40 transition-all duration-200 rounded-lg cursor-pointer group"
            (click)="onUploadClick()">
            @if (isUploading()) {
            <mat-spinner diameter="32"></mat-spinner>
            } @else {
            <div
                class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex flex-col items-center text-white drop-shadow-lg">
                <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span class="text-sm mt-1">{{ (getSpaceImage() ? 'spaceItem.changeImage' : 'spaceItem.uploadImage') | translate }}</span>
            </div>
            }
        </div>
        }
    </div>

    <!-- Parking Space Details Section (hidden for restricted members) -->
    @if (!isRestrictedMember()) {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5 mb-5 p-4 bg-gray-50 rounded-lg">

        <!-- Operator Name -->
        @if (parkingSpace.createdBy) {
        <div class="flex items-center text-sm">
            <span class="text-gray-600">{{ 'spaceItem.operator' | translate }}</span>
            <span class="ml-1 font-medium text-green-600">{{ parkingSpace.createdBy.firstName }} {{
                parkingSpace.createdBy.lastName }}</span>
        </div>
        }
        @else {
        <div class="flex items-center text-sm">
            <span class="text-gray-600">{{ 'spaceItem.operator' | translate }}</span>
            <span class="ml-1 font-medium text-red-600">{{ 'spaceItem.unassigned' | translate }}</span>
        </div>
        <!-- Assign Button
        <div class="flex items-center">
            <button type="button" (click)="assignOperator(parkingSpace.id)" class="text-sm text-blue-600 hover:underline">
                Assign Operator
            </button>
        </div> -->
        }
        <!-- Type -->
        @if (parkingSpace.type) {
        <div class="flex items-center text-sm">
            <svg class="h-4 w-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
            </svg>
            <span class="text-gray-600">{{ 'spaceItem.typeLbl' | translate }}</span>
            <span class="ml-1 font-medium text-gray-900">{{ parkingSpace.type }}</span>
        </div>
        }

        <!-- Access Mode -->
        @if (parkingSpace.accessMode) {
        <div class="flex items-center text-sm">
            <svg class="h-4 w-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <span class="text-gray-600">{{ 'spaceItem.accessLbl' | translate }}</span>
            <span class="ml-1 font-medium text-gray-900">{{ parkingSpace.accessMode }}</span>
        </div>
        }

        <!-- Entry Type -->
        @if (parkingSpace.entryType) {
        <div class="flex items-center text-sm">
            <svg class="h-4 w-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
            </svg>
            <span class="text-gray-600">{{ 'spaceItem.entryLbl' | translate }}</span>
            <span class="ml-1 font-medium text-gray-900">{{ parkingSpace.entryType }}</span>
        </div>
        }

        <!-- Total Zones -->
        <div class="flex items-center text-sm">
            <svg class="h-4 w-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            <span class="text-gray-600">{{ 'spaceItem.zonesLbl' | translate }}</span>
            <span class="ml-1 font-medium text-gray-900">{{ parkingSpace.parkingZones?.length || 0 }}</span>
        </div>

        <!-- Created Date -->
        @if (parkingSpace.createdAt) {
        <div class="flex items-center text-sm">
            <svg class="h-4 w-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <span class="text-gray-600">{{ 'spaceItem.createdLbl' | translate }}</span>
            <span class="ml-1 font-medium text-gray-900">{{ parkingSpace.createdAt | date:'shortDate' }}</span>
        </div>
        }

        <!-- Address -->
        @if (parkingSpace.address?.firstAddressLine || parkingSpace.address?.locality) {
        <div class="flex items-center text-sm">
            <svg class="h-4 w-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <span class="text-gray-600">{{ 'spaceItem.locationLbl' | translate }}</span>
            <span class="ml-1 font-medium text-gray-900 truncate">{{ parkingSpace.address?.firstAddressLine || '' }}
                {{
                parkingSpace.address?.locality || '' }}</span>
        </div>
        }
    </div>
    }

    <!-- Description (hidden for restricted members) -->
    @if (!isRestrictedMember() && parkingSpace.description) {
    <div class="mb-4 p-3 bg-blue-50 rounded-lg border-l-4 border-blue-400">
        <p class="text-sm text-blue-800">{{ parkingSpace.description }}</p>
    </div>
    }

    <!-- Action Buttons -->
    <div class="flex justify-start mb-4 gap-2">
        @if (!isRestrictedMember()) {
        <jjames-button [variant]="'primary'" matIconLeft="info" (clicked)="onParkingSpaceDetails(parkingSpace.id)">
            {{ 'spaceItem.details' | translate }}
        </jjames-button>
        }
        @if (parkingSpace.quickEasypassEnabled) {
        <jjames-button [variant]="'primary'" (clicked)="onQuickEasypass()" matIconLeft="confirmation_number">
            {{ 'quickEasypass.button' | translate }}
        </jjames-button>
        }
        <jjames-button [variant]="'secondary'" (clicked)="onHotline(parkingSpace.id)" matIconLeft="support_agent">
            {{ 'spaceItem.hotline' | translate }}
        </jjames-button>
        @if (!isRestrictedMember()) {
        <jjames-button [variant]="'secondary'" (clicked)="viewParkingProcesses()" matIconLeft="receipt_long">
            {{ 'spaceItem.processes' | translate }}
        </jjames-button>
        }
        @if (isAdmin()) {
        <jjames-button [variant]="'danger'" (clicked)="onDeleteParkingSpace(parkingSpace.id)" matIconLeft="delete">
            {{ 'spaceItem.delete' | translate }}
        </jjames-button>
        }
    </div>

    <!-- Zones Section (hidden for restricted members, and on sites whose zones only Administrators see) -->
    @if (!isRestrictedMember() && !zonesHidden()) {
    <app-parking-zone-list [zones]="parkingSpace.parkingZones || []" [parkingAreaId]="parkingSpace.id"
        (zoneDetails)="onZoneDetails($event)" (newZone)="onNewZone($event)">
    </app-parking-zone-list>
    }
</div>
<!-- Validation Errors Alert Modal -->
@if (showValidationErrorsFor && parkingSpace.validationErrors &&
parkingSpace.validationErrors.length > 0) {
<div class="fixed top-4 right-4 z-50 max-w-md">
    <jjames-alert type="error" [dismissible]="true" (dismissed)="onCloseAlert()">
        <div class="mb-2">
            <strong>{{ 'spaceItem.validationErrorsFor' | translate:{ name: (parkingSpace.name || ('spaceItem.spaceFallback' | translate)) } }}</strong>
        </div>
        <ul class="list-disc list-inside space-y-1">
            @for (error of parkingSpace.validationErrors; track error) {
            <li class="text-sm">{{ error }}</li>
            }
        </ul>
    </jjames-alert>
</div>
}
